export enum UnicodeEnum {
  NBSP = '\u00A0',
  RUB = '\u20BD',
  DOT = '\u{2022}',
}
